import { Capacitor } from '@capacitor/core';
import axios from 'axios';
import { getAuthHeaders } from './auth';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const isNativeApp = () => Capacitor.isNativePlatform();

// Debug/Xcode builds get sandbox APNs tokens; TestFlight/App Store get production.
const apnsEnvironment = () =>
  process.env.NODE_ENV === 'development' ? 'sandbox' : 'production';

export async function nativePushPermissionState() {
  const { PushNotifications } = await import('@capacitor/push-notifications');
  const perm = await PushNotifications.checkPermissions();
  return perm.receive; // 'prompt' | 'granted' | 'denied'
}

export async function registerNativePush() {
  const { PushNotifications } = await import('@capacitor/push-notifications');

  const registered = new Promise((resolve, reject) => {
    PushNotifications.addListener('registration', async ({ value }) => {
      try {
        await axios.post(`${API}/push/register-device`,
          { token: value, environment: apnsEnvironment() },
          { headers: getAuthHeaders() });
        resolve({ ok: true });
      } catch (e) { reject(e); }
    });
    PushNotifications.addListener('registrationError', (e) =>
      reject(new Error(e?.error || 'push registration failed')));
    setTimeout(() => reject(new Error('push registration timed out')), 15000);
  });

  let perm = await PushNotifications.checkPermissions();
  if (perm.receive === 'prompt') perm = await PushNotifications.requestPermissions();
  if (perm.receive !== 'granted') return { ok: false, denied: true };

  await PushNotifications.register();
  return registered;
}

export async function setupNativePushListeners(navigate) {
  if (!isNativeApp()) return;
  const { PushNotifications } = await import('@capacitor/push-notifications');
  PushNotifications.addListener('pushNotificationActionPerformed', (e) => {
    const url = e?.notification?.data?.url || '/today';
    navigate(url.startsWith('/') ? url : '/today');
  });
}
